import { useContext } from 'react';
import { Metadata, MetadataDuration } from '@openclassrooms/ui-web/learning-content';
import { translate } from '@openclassrooms/translations';

import CourseContext from '../../contexts/courseContext';

import Easy from './images/EasyIcon';
import Medium from './images/MediumIcon';
import Hard from './images/HardIcon';

function CourseMetadata() {
  const { course } = useContext(CourseContext);
  const { displayDifficulty, difficulty, duration } = course;

  const iconsPerDifficulty = {
    Easy,
    Medium,
    Hard,
  };

  const translations = {
    durationHours: (count: number) =>
      translate('learning_content.duration.hours', { count }, count),
    durationMinutes: (count: number) =>
      translate('learning_content.duration.minutes', { count }, count),
  };

  const difficultyIcon = iconsPerDifficulty[difficulty] || Hard;

  return (
    <div>
      <Metadata
        icon={difficultyIcon}
        shouldNotWrap
        accessibilityLabel={translate('courses.accessibility_labels.difficulty')}
      >
        {displayDifficulty}
      </Metadata>

      <MetadataDuration shouldNotWrap duration={duration} translations={translations} />
    </div>
  );
}

export default CourseMetadata;
